// extracted by mini-css-extract-plugin
module.exports = {"discount":"dd31006766--discount--1M7ou"};